<template>
  <InputToggle
    :value="props?.context?._value"
    @input="handleInput"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  context: Object,
  required: Boolean,
})

props?.context?.node?.input(!!props.context._value)

function handleInput(event: Event) {
  props?.context?.node?.input((event.target as HTMLInputElement).checked)
}
</script>
